import React from 'react';
import RichTextBody from './RichTextBody';
// import { useIntl } from 'react-intl';

const Overview: React.FC<{ element: any }> = ({ element }) => {
  //   const { formatMessage } = useIntl();

  if (!element.value || element.value === '<p><br></p>') {
    return null;
  }

  return (
    <div>
      <RichTextBody element={element} isInsideTable={false} />
    </div>
  );
};

export default Overview;
